import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-blue",
  "use": "icon-menu-blue-usage",
  "viewBox": "0 0 20 13.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 13.33\" id=\"icon-menu-blue\"><title>icon-menu-blue</title><path d=\"M20,13.33H0V11.09H20Zm0-5.57H0V5.57H20Zm0-5.52H0V0H20Z\" style=\"fill:#1e4f71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol